import React, { useState } from "react";
import { Check, Loader2Icon } from "lucide-react";
import { Header } from "@/components/shared/ui/text";
import { useQueryClient } from "@tanstack/react-query";
import api from "@/api/base";
import { useMeQuery } from "@/queries/queries";
import { Button } from "@/components/shared/ui/button";

const ConnectProperty: React.FC = () => {
  const [activatePropertyStatus, setActivatePropertyStatus] = useState<
    string | null
  >(null);
  const queryClient = useQueryClient();
  const { data: user } = useMeQuery();
  const companyId = user?.company.id;

  const handleActivatePropertyClick = async () => {
    setActivatePropertyStatus("loading");
    await api.post(`/company/${companyId}/refresh_espm_data/`).then(() => {
      queryClient.invalidateQueries();
    });
    setActivatePropertyStatus("success");
  };

  return (
    <div className="flex flex-col gap-2 p-4">
      <Header className="text-md">
        1. Click
        <a
          href="https://portfoliomanager.energystar.gov/pm/sharing/wsBulkSharing"
          target="_blank"
          className="underline text-blue-500 px-1"
          rel="noreferrer"
        >
          here
        </a>
        to share new properties.
      </Header>
      <Header className="text-md">
        2. Once you send the share request, click the button below to have it
        accepted.
      </Header>
      <div className="flex flex-row gap-2 py-2 pr-4">
        <img
          src="/ESPM_Connect_Step5.png"
          alt="Step4"
          className="max-w-full h-auto"
        />
      </div>
      <div className="flex items-center gap-2">
        <Button
          type="button"
          onClick={handleActivatePropertyClick}
          disabled={activatePropertyStatus === "loading"}
        >
          I've shared the building — check now
        </Button>
        {activatePropertyStatus === "loading" ? (
          <Loader2Icon className="animate-spin" size={18} />
        ) : null}
        {activatePropertyStatus === "success" ? (
          <Check className="stroke-green-500" size={18} />
        ) : null}
      </div>
    </div>
  );
};

export default ConnectProperty;
